<div class="d-flex align-items-end">
  <textarea class="form-control" placeholder="Write your comment..." #textarea [(ngModel)]="rawValue" (input)="onChange()" (blur)="onBlur()"></textarea>
  <div class="ml-2">
    <div *ngIf="value" class="text-center">
      <a href="javascript:" (click)="onCancel()">Cancel</a>
    </div>
    <button class="btn mt-2 px-4 btn-sm" [ngClass]="{'btn-primary': !disabled, 'btn-default': disabled}" [disabled]="disabled" (click)="onSubmit()">POST</button>
  </div>
</div>
